import * as React from "react";

interface SendStatusBadgeProps {
  sentCount: number;
  skippedCount: number;
  sentAt: string | null;
}

function formatSentAt(sentAt: string): string {
  const date = new Date(sentAt);
  return date.toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function SendStatusBadge({ sentCount, skippedCount, sentAt }: SendStatusBadgeProps) {
  return (
    <div role="status" data-testid="send-status" className="text-sm text-slate-600 space-y-0.5">
      <span>
        Sent {sentCount} · Skipped {skippedCount}
      </span>
      {sentAt !== null && (
        <p className="text-xs text-slate-400">Last sent {formatSentAt(sentAt)}</p>
      )}
    </div>
  );
}
